// ========================================================================
// SET RATIO
// ========================================================================

$(function() {
	function setRatio() {
		var value = $(window).width(),
			ratio = ($('.type--homepage').length) ? 12.29 : 6.4;
		value *= 1;
		var height = Math.round((value/16)*ratio),
			height = ((height < $(window).height()) ? height : $(window).height()) + 'px';
		$('.header').css('height', height);
	}

	$(document).ready(setRatio());
	$(window).on('resize orientationchange', function() {
		setRatio();
	});
});